import http from "infra/http";
import { useQuery } from "react-query";
import { ListaRelatoriosResponse, ListaRelatoriosParams} from "../typings";

function useListaRelatoriosPorGrupo(params?: ListaRelatoriosParams) {
  const queryResult = useQuery([`/v1/relatorios/por-grupo`, params], async () => {
    const { data } = await http.get<ListaRelatoriosResponse[]>(`/v1/relatorios/por-grupo`, {
      params
    });

    return data;
  });

  return queryResult;
}

export default useListaRelatoriosPorGrupo;
